import { GlobalState } from '../../actions';

const userAdminSelector = (state: GlobalState) => state.userAdmin;

export const userAdminProfileSelector = (state: GlobalState) => userAdminSelector(state).profile;
export const userAdminMergeBetsCountSelector = (state: GlobalState) => userAdminSelector(state).mergeBetCount;